import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import RIASECTabs from 'components/organisms/RIASECTabs'

const RIASECExplanation = () => (
  <div className="riasec-explanation">
    <SectionContainer
      className="riasec-explanation__section"
      paddingTop={80}
      backgroundColor="#f6f7fa"
    >
      <RIASECTabs />
    </SectionContainer>
  </div>
)

export default RIASECExplanation
